import React from 'react';
import { Grid } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import SparksHistorySearch from './SparksHistorySearch';
import SparksHistoryResult from './SparksHistoryResult';
import type { JoinedSparks } from 'types/Spark/JoinedSpark';
import { DateRange } from 'sharedComponents/UI/SparkDateRangePicker';
import moment from 'moment';

export type HistoryFilter = {
  sparkIDs?: JoinedSparks['id'][];
  dateRange: DateRange;
};

function SparkHistory() {
  const [searchParams] = useSearchParams();

  const sparkID = searchParams.get('sparkID');

  const initialFilter: HistoryFilter = {
    sparkIDs: sparkID ? [sparkID] : [],
    dateRange: {
      startDate: moment().subtract(1, 'month'),
      endDate: moment(),
    },
  };

  const [historyFilter, setHistoryFilter] =
    React.useState<HistoryFilter>(initialFilter);

  return (
    <Grid container>
      <SparksHistorySearch
        setHistoryFilter={setHistoryFilter}
        historyFilter={historyFilter}
        resetFilters={() => setHistoryFilter(initialFilter)}
      />
      <SparksHistoryResult historyFilter={historyFilter} />
    </Grid>
  );
}

export default SparkHistory;
